import axios from "axios"
import { logOut } from "../actions/AuthAction";
import store from '../store/ReduxStore';

const API = axios.create({baseURL: process.env.REACT_APP_API_BASE_URL, withCredentials: true});

API.interceptors.response.use(
    response => response, 
    error => {
        if (error.response && error.response.status === 401) {
            console.log("Token expired, logging out user...");

            // Dispatch logout action
            store.dispatch(logOut());
        }
        return Promise.reject(error);
    }
);
// API.interceptors.request.use((req)=> {
//     if (localStorage.getItem('profile')) {
//         req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem('profile').token)}`
//     }
//     return req;
// })

export const getUser = (userId, logDetails) => API.get(`/user/${userId}/${logDetails}`)
// export const getUsers = (id, action) => API.get(`/user/${action}/${id}`)

export const followUser = (id, body) => API.put(`/user/${id}/follow`, body)
export const subscribeUser = (id, body) => API.put(`/user/${id}/subscribe`, body)
export const updateUser = (id, formData, sessionId) => API.put(`/user/${id}/update`, {...formData, sessionId})
export const updateTransferrence = (id, data, sessionId) => API.put(`/user/${id}/transferrence`, {...data, sessionId})
export const searchUsers = (username, userType = null) => 
    userType !== null 
        ? API.get(`/userfeed/search/${username}/${userType}`)
        : API.get(`/userfeed/search/${username}`);